import { jsx as r } from "react/jsx-runtime";
import { Y as l } from "../../vendor-Dd6qj6gJ.js";
import { c as e } from "../../styles.module-BF2N4g8-.js";
function m({ children: a, ...o }) {
  return /* @__PURE__ */ r(l, { className: e.toolbar, "aria-label": o["aria-label"], children: a });
}
m.displayName = "Table.Toolbar";
export {
  m as Toolbar
};
